import { useTheme } from '@mui/material';
import { memo } from 'react';
import ContentLoader from 'react-content-loader';

interface WaveLoaderProps {
  height: string | number;
  className?: string;
  style?: React.CSSProperties;
}

function WaveformLoader_({ height, style, ...props }: WaveLoaderProps) {
  const theme = useTheme();

  return (
    <ContentLoader
      // 1. Force the SVG to fill the available space defined by the parent or style
      width="100%"
      height="100%"
      // 2. Keep the ViewBox locked to your Path's native coordinates (0-1440 width)
      viewBox="0 0 1440 232"
      // 3. This is the key: It tells the SVG to ignore the 1440x116 ratio
      // and stretch/squash the path to fill strictly whatever box you put it in.
      preserveAspectRatio="none"
      // Default styles (overridable)
      backgroundColor={theme.palette.mode === 'dark' ? theme.palette.background.paper : '#f3f3f3'}
      foregroundColor={theme.palette.mode === 'dark' ? theme.palette.divider : '#b2c0cd'}
      speed={2}
      // Apply user styles (allows you to control height/margin from outside)
      style={{
        width: '100%',
        height: height,
        display: 'block', // Removes vague SVG bottom spacing
        ...style,
      }}
      {...props}
    >
      {/* Top Half (Original) */}
      <use href="#global-waveform-path" fill="currentColor" />

      {/* Bottom Half (Mirrored) */}
      {/* translate(0, 232) moves origin to bottom, scale(1, -1) flips it up */}
      <use
        href="#global-waveform-path"
        transform="translate(0, 232) scale(1, -1)"
        fill="currentColor"
      />
    </ContentLoader>
  );
}

export const WaveformLoader = memo(WaveformLoader_);
